import axios from 'axios';
import api from './ApiAuthService';

export async function getAdvertising(filters : any): Promise<any> {
  try {
    const response = await api.post('/posts/banner/advertisement', filters);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar o anuncio', error);
    throw new Error('Erro ao carregar a página');
  }
}

export async function postAdvertisingClick(banner_id : number): Promise<any> {
  try {
    await api.post('/posts/banner/interaction/' + banner_id, {});
    // return response.data;
  } catch (error) {
    // console.error('Erro ao carregar o anuncio', error);
    // throw new Error('Erro ao carregar a página');
  }
}